<div *ngIf="isLoading" class="bg-white rounded-2xl shadow-lg p-8 relative absolute top-0 left-0 w-full h-full flex items-center justify-center bg-white opacity-50">
  <mat-spinner diameter="50"></mat-spinner>
</div>
<div *ngIf="!isLoading" class="bg-white rounded-2xl shadow-lg p-8 relative">
  <div class="flex items-center gap-8 border-b pb-8 mb-8">
    <img
      src="/images/vfifc-logo.png"
      alt="avatar"
      class="w-20 h-20 rounded-full border-4 border-primary-600 shadow-md bg-gradient-to-br from-primary-500 to-primary-700"
    />

    <div>
      <h2 class="text-2xl font-extrabold text-gray-800">{{user.name}}</h2>
      <p class="text-gray-500 mt-1" *ngIf="user.nationalId">
        National ID: <span class="font-medium text-gray-700">{{user.nationalId}}</span>
      </p>
      <p class="text-gray-500" *ngIf="user.dateOfBirth">
        Date of Birth: <span class="font-medium text-gray-700">{{user.dateOfBirth}}</span>
      </p>
      <p class="text-gray-500" *ngIf="user.gender">Gender: <span class="font-medium text-gray-700">{{user.gender}}</span></p>
    </div>
  </div>

  
  <button (click)="closeDialog()" class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 font-bold text-lg">
    <mat-icon class="!text-[24px] !w-[24px] !h-[24px]">close</mat-icon>
  </button>

  <div class="mb-10">
    <h3 class="text-lg font-semibold text-gray-800 border-l-4 border-primary-600 pl-3 mb-4">
      📞 Contact Information
    </h3>
    <div class="grid grid-cols-2 gap-y-2 gap-x-8">
      <p class="text-gray-500" *ngIf="user.email">
        Email: <span class="font-medium text-gray-700">{{user.email}}</span>
      </p>
      <p class="text-gray-500" *ngIf="user.phone">Phone: <span class="font-medium text-gray-700">{{user.phone}}</span></p>
    </div>
  </div>

  <div class="mb-10">
    <h3 class="text-lg font-semibold text-gray-800 border-l-4 border-primary-600 pl-3 mb-4">
      Account Details
    </h3>
    <div class="">
      <p class="text-gray-500">
        Status:
        <span class="px-2 py-1 rounded-full text-xs font-semibold bg-primary-100 text-primary-700">
          {{user.status}}
        </span>
      </p>
      <p class="text-gray-500" *ngIf="user.createdAt">
        Created At: <span class="font-medium text-gray-700">{{user.createdAt | date:'medium'}}</span>
      </p>
      <p class="text-gray-500" *ngIf="user.updatedAt">
        Updated At: <span class="font-medium text-gray-700">{{user.updatedAt | date:'medium'}}</span>
      </p>
      <p class="text-gray-500" *ngIf="user.updatedBy">
        Updated By: <span class="font-medium text-gray-700">{{user.updatedBy}}</span>
      </p>
    </div>
  </div>

  <div class="mb-10">
    <h3 class="text-lg font-semibold text-gray-800 border-l-4 border-primary-600 pl-3 mb-4">
      Role
    </h3>
    <div class="mb-3">
      <h4 class="text-md font-semibold text-primary-600 mb-2">{{user?.roles?.[0] | removeUnderscore}}</h4>
    </div>
  </div>

  <!-- Signature -->
  <!-- <div class="mb-10">
    <h3 class="text-lg font-semibold text-gray-800 border-l-4 border-primary-600 pl-3 mb-4 mt-4">
      Signature
    </h3>
    <div class="flex flex-col items-center">
      <label
        class="relative border-2 border-dashed border-gray-400 rounded-xl flex justify-center items-center overflow-hidden shadow focus:outline-none w-44 h-28 cursor-pointer hover:border-primary-600 transition"
      >
        <img
          class="object-contain w-full h-full opacity-25"
          src="https://via.placeholder.com/150x80?text=Signature"
          alt="Signature"
        />
        <input type="file" class="hidden" />
      </label>
      <span class="text-sm text-gray-500 mt-2"> Upload your signature </span>
    </div>
  </div> -->

  <div *appHasPermission="'USER_UPDATE'" class="tems-center justify-center flex gap-2 mt-4">
    <button
      (click)="activateUser()"
      class="px-5 py-2.5 rounded-xl bg-primary-600 text-white font-semibold shadow hover:bg-primary-700 transition"
    >
      Activate
    </button>
    <button
      (click)="deactivateUser()"
      class="px-5 py-2.5 rounded-xl bg-red-600 text-white font-semibold shadow hover:bg-red-700 transition"
    >
      Deactivate
    </button>
    <button
      (click)="suspendUser()"
      class="px-5 py-2.5 rounded-xl bg-yellow-600 text-white font-semibold shadow hover:bg-yellow-700 transition"
    >
      Suspend
    </button>
  </div>
</div>
